/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type PatchCurrentContractPensionSavingBodyInvestmentToolType =
  (typeof PatchCurrentContractPensionSavingBodyInvestmentToolType)[keyof typeof PatchCurrentContractPensionSavingBodyInvestmentToolType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchCurrentContractPensionSavingBodyInvestmentToolType = {
  pension_saving: "pension_saving",
} as const;
